import React from 'react';
import { Container, Dimmer, Table, Card, Button, Avatar, Page } from "tabler-react";
import SearchInput from '../../components/searchInput';

const RecordsTable = ({
    headers,
    records,
    openMainModal,
    loading,
    reload,
    searchQuery,
    onSearch
}) => {
    return (
        <Container>
            <Page.Header>
                <Page.Title>Admins</Page.Title>
            </Page.Header>

            <Card>
                <Dimmer active={loading} loader={loading}>
                    <Card.Header>
                        <Card.Options>
                            <SearchInput value={searchQuery} onSubmit={onSearch} />

                            <Button
                                className="ml-2"
                                icon="plus"
                                color="primary"
                                size="md"
                                onClick={() =>
                                    openMainModal('admin-user-create', null, reload)
                                }
                            >
                                Create Admin
                            </Button>
                        </Card.Options>
                    </Card.Header>

                    {!loading && records.length < 1 ? (
                        <div className="alert alert-primary m-0">
                            No Users to show!
                        </div>
                    ) : (
                        <div className="table-responsive-wrapper">
                            <Table hasOutline striped>
                                <Table.Header>
                                    {headers.map((head, i) => (
                                        <Table.ColHeader key={`tableHeader-${i}`}>
                                            {head}
                                        </Table.ColHeader>
                                    ))}
                                    <Table.ColHeader>Actions</Table.ColHeader>
                                </Table.Header>

                                <Table.Body>
                                    {records.map((r, i) => (
                                        <Table.Row key={i}>
                                            {Object.keys(r).map((k) => {
                                                if (k === 'id' || k === 'isVerified') return null;

                                                if (k === 'image') {
                                                    return (
                                                        <Table.Col key={k}>
                                                            <Avatar
                                                                size="sm"
                                                                imageURL={r['image']}
                                                            />
                                                        </Table.Col>
                                                    );
                                                }

                                                return (
                                                    <Table.Col key={k}>
                                                        {r[k]}
                                                    </Table.Col>
                                                );
                                            })}

                                            <Table.Col>
                                                <div className="actions-wrap">
                                                    <Button
                                                        outline
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() =>
                                                            openMainModal(
                                                                'admin-user-edit',
                                                                r.id,
                                                                reload
                                                            )
                                                        }
                                                    >
                                                        Edit
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="danger"
                                                        className="ml-2 mr-2"
                                                        size="sm"
                                                        onClick={() =>
                                                            openMainModal(
                                                                'admins--delete',
                                                                r.id,
                                                                reload
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>

                                                    {!r.isVerified && (
                                                        <Button
                                                            outline
                                                            color="success"
                                                            size="sm"
                                                        >
                                                            Verify
                                                        </Button>
                                                    )}
                                                </div>
                                            </Table.Col>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>
                    )}
                </Dimmer>
            </Card>
        </Container>
    );
};

export default RecordsTable;